var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 21.3333C18.209 21.3333 19.9998 19.5425 19.9998 17.3333C19.9998 15.1242 18.209 13.3333 15.9998 13.3333C13.7907 13.3333 11.9998 15.1242 11.9998 17.3333C11.9998 19.5425 13.7907 21.3333 15.9998 21.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 6.66667H22.4398L20.7865 4.86667C20.2932 4.32 19.5732 4 18.8265 4H13.1732C12.4265 4 11.7065 4.32 11.1998 4.86667L9.55984 6.66667H5.33317C3.8665 6.66667 2.6665 7.86667 2.6665 9.33333V25.3333C2.6665 26.8 3.8665 28 5.33317 28H26.6665C28.1332 28 29.3332 26.8 29.3332 25.3333V9.33333C29.3332 7.86667 28.1332 6.66667 26.6665 6.66667ZM15.9998 24C12.3198 24 9.33317 21.0133 9.33317 17.3333C9.33317 13.6533 12.3198 10.6667 15.9998 10.6667C19.6798 10.6667 22.6665 13.6533 22.6665 17.3333C22.6665 21.0133 19.6798 24 15.9998 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e5c340053e4f2580849009276448cf82.svg";
export { ForwardRef as ReactComponent };